import axiosInstance from './axios';

export const cityService = {
  getCities: async (params = {}) => {
    const response = await axiosInstance.get('/cities/all', { params });
    return response.data;
  },

  getCity: async (id) => {
    const response = await axiosInstance.get(`/cities/${id}`);
    return response.data;
  },

  createCity: async (cityData) => {
    const response = await axiosInstance.post('/cities', cityData);
    return response.data;
  },

  updateCity: async (id, cityData) => {
    const response = await axiosInstance.put(`/cities/${id}`, cityData);
    return response.data;
  },

  deleteCity: async (id) => {
    const response = await axiosInstance.delete(`/cities/${id}`);
    return response.data;
  },
};
